import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { linkTargets } from "core/props";

import PlaceholderGif from "./images/placeholder.gif";
import { ImageContainer, Image, PlaceholderImage } from "./styles";

const UnstyledImagePreventRightClick = ({
    className,
    srText,
    imageSrc,
    href = false,
    target = "_self",
    usePlaceholder = false,
    backgroundSize,
    backgroundPosition
}) => {
    // if href is passed, render an anchor tag, else render div:
    const imageContainerElementType = href ? "a" : "div";

    // support both webpack (string) & next.js (object) image imports
    const src = !!imageSrc && imageSrc.src ? imageSrc.src : imageSrc;
    const placeholder =
        !!PlaceholderGif && PlaceholderGif.src
            ? PlaceholderGif.src
            : PlaceholderGif;

    // return props in relation to href if href exists, else default props:
    const containerProps = href
        ? {
              href,
              target,
              className
          }
        : {
              className
          };

    return (
        <ImageContainer
            {...containerProps}
            as={imageContainerElementType}
            title={srText}
        >
            {/* use placeholder when space needs to be reserved for scaling, ex: home page collections tiles: */}
            {usePlaceholder ? (
                <PlaceholderImage
                    src={placeholder}
                    source={src}
                    backgroundSize={backgroundSize}
                    backgroundPosition={backgroundPosition}
                    alt={srText}
                />
            ) : (
                <Image src={src} alt={srText} />
            )}
        </ImageContainer>
    );
};

const ImagePreventRightClick = styled(UnstyledImagePreventRightClick)``;

ImagePreventRightClick.propTypes = {
    className: PropTypes.string,
    srText: PropTypes.string.isRequired,
    imageSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
    href: PropTypes.string,
    target: PropTypes.oneOf(linkTargets),
    usePlaceholder: PropTypes.bool,
    backgroundSize: PropTypes.string,
    backgroundPosition: PropTypes.string
};

export default ImagePreventRightClick;
